import Logo from "../../components/Navigation/Logo";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { Background } from "./components/Background";

export const SubmissionReceived = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <Background />
      <div className="absolute top-0 left-0 w-full z-50 px-8 py-6">
        <div className="max-w-7xl mx-auto">
          <Logo />
        </div>
      </div>
      <div className="relative z-10 desktop:px-24 laptop:px-16 tablet:px-8 mobile:px-4 min-h-screen flex items-center justify-center">
        <div className="w-full max-w-xl opacity-100 translate-y-0">
          <div className="bg-gradient-to-br from-stone-800/40 via-stone-900/40 to-black/40 rounded-3xl p-8 border border-stone-700/20 backdrop-blur-md shadow-2xl text-center">
            <div className="flex justify-center mb-8">
              <IoCheckmarkCircle className="text-emerald-400 w-24 h-24" />
            </div>
            <h2 className="text-white text-3xl font-semibold mb-4">
              Registration Submitted!
            </h2>
            <p className="text-amber-100/80 text-lg mb-8">
              Thank you for registering for our AI dinner. We'll be in touch
              with you shortly to confirm your reservation.
            </p>
            <div className="flex desktop:flex-row laptop:flex-row tablet:flex-row mobile:flex-col gap-4">
              <Link to="/" className="flex-1">
                <button className="w-full bg-stone-800/30 hover:bg-stone-800/40 text-white text-base font-medium px-6 py-3 rounded-xl backdrop-blur-sm transition-all duration-300 border border-white/10 hover:border-amber-500/30">
                  Return Home
                </button>
              </Link>
              <Link to="/calendar" className="flex-1">
                <button className="w-full bg-gradient-to-br from-amber-500 via-amber-600 to-orange-600 hover:from-amber-400 hover:via-amber-500 hover:to-orange-500 text-white text-base font-medium px-6 py-3 rounded-xl shadow-lg shadow-amber-900/30 transition-all duration-300 border border-amber-500/20">
                  Browse More Events
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
